/* OCG — Klaviyo star-ratings fallback (Jul 2026, v2 conflict-safe)
 * BUG: some product cards arrive via AJAX (e.g. "Get The Full Look" / Cycling
 * Kits tabs) AFTER Klaviyo's onsite script scanned the DOM, so those widgets
 * stay empty. FIX: batch-fetch Klaviyo's public client_reviews endpoint and
 * render the stars ourselves.
 * v2: Klaviyo is AUTHORITATIVE. We only fill widgets Klaviyo has NOT rendered,
 * and if Klaviyo renders one later (its .kl_reviews__ nodes appear), we REMOVE
 * our own render so the rating never shows twice (Graziela 08-Jul: "aparecem 2x
 * o rating"). Our render lives in a single <span data-ocg-stars> we can pull.
 */
(function () {
  'use strict';
  var COMPANY = 'Wh5mzb';
  var STAR_ON = '#F8BE00', STAR_OFF = '#d9d9d9', TEXT = '#202223';
  var KL_NATIVE = '.kl_reviews__star_rating_widget, .kl_reviews__stars_badge, .kl_stars';
  var pending = Object.create(null);
  var timer = null;

  function star(color) {
    return '<svg viewBox="0 0 20 20" width="16" height="16" style="display:block">' +
      '<path fill="' + color + '" d="M10 1.5l2.6 5.3 5.9.9-4.2 4.1 1 5.8L10 14.9l-5.3 2.7 1-5.8L1.5 7.7l5.9-.9z"/></svg>';
  }
  function starSvg(fillPct) {
    return '<span style="position:relative;display:inline-block;width:16px;height:16px;vertical-align:-2px">' +
      star(STAR_OFF) +
      '<span style="position:absolute;left:0;top:0;width:' + fillPct + '%;height:100%;overflow:hidden">' + star(STAR_ON) + '</span>' +
      '</span>';
  }

  // has Klaviyo itself rendered into this widget?
  function klaviyoRendered(el) {
    if (el.querySelector && el.querySelector(KL_NATIVE)) return true;
    // any non-ours child element with content == someone else rendered
    for (var i = 0; i < el.children.length; i++) {
      if (!el.children[i].hasAttribute('data-ocg-stars')) return true;
    }
    return false;
  }

  // if Klaviyo renders later, drop our node so it never doubles
  function watchForKlaviyo(el) {
    var mo = new MutationObserver(function () {
      if (el.querySelector(KL_NATIVE)) {
        var ours = el.querySelector('[data-ocg-stars]');
        if (ours) ours.remove();
        mo.disconnect();
      }
    });
    mo.observe(el, { childList: true, subtree: true });
    // stop watching after 20s (Klaviyo has long since run by then)
    setTimeout(function () { mo.disconnect(); }, 20000);
  }

  function render(el, rating, count) {
    if (klaviyoRendered(el)) return; // Klaviyo beat us — leave it
    var r = Math.max(0, Math.min(5, rating || 0));
    var html = '<span style="display:inline-flex;align-items:center;gap:1px">';
    for (var i = 1; i <= 5; i++) {
      var fill = Math.round(Math.max(0, Math.min(1, r - (i - 1))) * 100);
      html += starSvg(fill);
    }
    html += '</span>';
    if (count > 0) {
      html += '<span style="margin-left:6px;color:' + TEXT + ';font-size:13px">' + count + ' Review' + (count === 1 ? '' : 's') + '</span>';
    }
    var wrap = document.createElement('span');
    wrap.setAttribute('data-ocg-stars', '1');
    wrap.style.display = 'inline-flex';
    wrap.style.alignItems = 'center';
    wrap.innerHTML = html;
    el.appendChild(wrap);
    el.style.visibility = 'visible';
    el.style.height = 'auto';
    watchForKlaviyo(el);
  }

  function flush() {
    timer = null;
    var ids = Object.keys(pending);
    if (!ids.length) return;
    var batch = pending; pending = Object.create(null);
    var url = 'https://fast.a.klaviyo.com/reviews/api/client_reviews/?company_id=' + COMPANY +
              '&products=' + encodeURIComponent(JSON.stringify(ids));
    fetch(url).then(function (r) { return r.json(); }).then(function (j) {
      var byId = {};
      (j.products || []).forEach(function (pr) { byId[String(pr.external_id || pr.shopify_id)] = pr; });
      ids.forEach(function (id) {
        var pr = byId[id];
        (batch[id] || []).forEach(function (el) {
          if (klaviyoRendered(el) || el.getAttribute('data-ocg-done')) return;
          el.setAttribute('data-ocg-done', '1');
          render(el, pr ? pr.star_rating : 0, pr ? pr.review_count : 0);
        });
      });
    }).catch(function () { /* network fail: leave widgets as-is */ });
  }

  function queue(el) {
    var id = el.getAttribute('data-id');
    if (!id || klaviyoRendered(el) || el.getAttribute('data-ocg-done')) return;
    (pending[id] = pending[id] || []).push(el);
    if (timer) clearTimeout(timer);
    timer = setTimeout(flush, 1200); // give Klaviyo's own scan first shot
  }

  function scan(root) {
    (root.querySelectorAll ? root.querySelectorAll('.klaviyo-star-rating-widget') : []).forEach(queue);
  }

  // belt-and-suspenders: if any widget ends up with BOTH our render and
  // Klaviyo's native one (observer lost the race), drop ours. Never 2x.
  function dedupeSweep() {
    document.querySelectorAll('.klaviyo-star-rating-widget').forEach(function (el) {
      var ours = el.querySelector('[data-ocg-stars]');
      if (ours && el.querySelector(KL_NATIVE)) ours.remove();
    });
  }

  function start() {
    // late first pass so Klaviyo's own render wins by default
    setTimeout(function () { scan(document); }, 5000);
    [6000, 9000, 13000, 18000].forEach(function (t) { setTimeout(dedupeSweep, t); });
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes && m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          if (n.classList && n.classList.contains('klaviyo-star-rating-widget')) queue(n);
          else if (n.querySelectorAll) scan(n);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
